import React from "react";
import { shallowEqual } from "react-redux";
import { useUscSelector } from "../../../../redux/store";
import { getSimplifiedTotalPriceSelector } from "../../../../utils/priceUtils";
import UscInlineMonthlyPrice from "./UscInlineMonthlyPrice";
import { useUscLabel } from "../../../../utils/labels";
import Text from "../../styles/atoms/Text";
import * as Styles from "./UscInlinePrices.styles";

type UscInlinePricesType = {
    inBasketDetailsModal?: boolean;
};

/**
 * The inline cash prices are rendered in case the prices are hidden in the finance toggle
 * Related setting: hideFinanceTogglePrices
 *
 */
const UscInlinePrices = ({ inBasketDetailsModal }: UscInlinePricesType): JSX.Element | null => {
    const totalCashLabel = useUscLabel("uscBasketOverviewTotalCash");

    const { cash } = useUscSelector(getSimplifiedTotalPriceSelector(), shallowEqual);
    const showPricesInsideToggle = useUscSelector((state) => !state.uscSettings.hideFinanceTogglePrices);
    const activeFinanceOption = useUscSelector((state) => state.basket.activeFinanceOption);

    if (showPricesInsideToggle) return null;

    return (
        <Styles.Wrapper inBasketDetailsModal={inBasketDetailsModal}>
            {activeFinanceOption === "cash" ? (
                <>
                    <Text tag="span" variant={inBasketDetailsModal ? "h7" : "button-semibold"}>
                        {totalCashLabel}
                    </Text>
                    <Text tag="span" variant={inBasketDetailsModal ? "body-small-semibold" : "button-semibold"}>
                        <span dangerouslySetInnerHTML={{ __html: cash }} />
                    </Text>
                </>
            ) : (
                <UscInlineMonthlyPrice inBasketDetailsModal={inBasketDetailsModal} />
            )}
        </Styles.Wrapper>
    );
};

export default UscInlinePrices;
